import { RhInputFormik } from "@rhythm-ui/react";
import dayjs from "dayjs";
import { Form, Formik } from "formik";
import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";

import { RootState } from "@/redux/types";

import { Button } from "@/components/ui/Button";
import {
  Dialog,
  DialogBody,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog";

import { OpportunityContext } from "../constants";
import { setIsDroppedInCulturalStageDialogOpen } from "../stageAndStatusPopoverForCandidateOpportunitiesSlice";
import { FormSubmissionValues } from "../types";
import EventDateTimeField from "./EventDateTimeField";

type TDroppedInCulturalStageDialogProps = {
  handleSubmit: (values: FormSubmissionValues) => void;
};

const DroppedInCulturalStageDialog = (
  props: TDroppedInCulturalStageDialogProps,
) => {
  const opportunity = useContext(OpportunityContext);
  const dispatch = useDispatch();
  const isOpen = useSelector(
    (state: RootState) =>
      state.stageAndStatusPopoverForCandidateOpportunitiesSlice
        .isDroppedInCulturalStageDialogOpen,
  );

  const handleSubmit = (values: FormSubmissionValues) => {
    props.handleSubmit(values);
    handleClose();
  };

  if (
    !isOpen ||
    isOpen.id !== opportunity?.job_id ||
    isOpen.candidate_id !== opportunity.candidate_id
  )
    return null;

  const handleClose = () => {
    dispatch(
      setIsDroppedInCulturalStageDialogOpen({
        id: opportunity?.job_id,
        open: false,
        candidate_id: opportunity.candidate_id,
      }),
    );
  };

  return (
    <Dialog isOpen={isOpen?.open || false} className="w-[600px]">
      <DialogHeader>
        <DialogTitle>Candidate Dropped in Cultural Stage</DialogTitle>
        <DialogDescription>
          Provide a reason and date when the candidate dropped out in the
          Cultural Stage
        </DialogDescription>
      </DialogHeader>

      <Formik
        initialValues={{
          detailed_reason: "",
          event_time: dayjs().toISOString(),
        }}
        onSubmit={handleSubmit}
        validationSchema={Yup.object().shape({
          detailed_reason: Yup.string().required("Please provide a comment"),
          event_time: Yup.string().required("Please provide an event date"),
        })}
      >
        <Form>
          <DialogBody className="space-y-4">
            <RhInputFormik
              name="detailed_reason"
              type="textarea"
              className="w-full"
              rows={4}
              autoFocus
              placeholder="Enter your comment"
            />

            <EventDateTimeField name="event_time" />
          </DialogBody>

          <DialogFooter>
            <Button variant="tertiary" onClick={handleClose}>
              Cancel
            </Button>
            <Button type="submit">Submit</Button>
          </DialogFooter>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default DroppedInCulturalStageDialog;
